export const BLUETOOTH_FILTER_PREFIX: string = "Scout ";

export const BLUETOOTH_STATES = {
  UNSUPPORTED: "unsupported",
  DISCONNECTED: "disconnected",
  CONNECTING: "connecting",
  SCANNING: "scanning",
  CONNECTED: "connected",
  WIFI_CONNECTING: "wifi_connecting",
};

export const BLUETOOTH_DC_REASONS = {
  NONE: 0,
  UNKNOWN: 1,
  DEVICE_RESTART: 2,
  SETUP: 3,
};
